module.exports = __webpack_public_path__ + "static/media/LogoSemFundo.da464f48.png";